const namespaced = true;

const state = {
  price: null,
};

const mutations = {
  SET_PRICE(state, price) {
    state.price = price;
  },
};

const actions = {
  setPrice({ commit }, price) {
    commit('SET_PRICE', price);
  },
};

const getters = {
  price: state => state.price,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};